import type React from 'react'
import type { JSX } from 'react'
import type { IRowContainerProps, RowPaddings } from '../RowContainer.h'

import { useMemo } from 'react'
import { InlineForwardArrowWithTitle } from 'atoms/Button/Templates'
import { IconNames } from 'atoms/Icon'
import { ContainerHeaderWithTitleOnly } from 'blocks/Container/Header/Templates'
import { RowTitleSC } from '../NewRowContainer.styled'
import { RowControlsType } from '../RowContainer.h'
import { HeaderControls } from './HeaderControls'

export interface IRowTitle extends Omit<
  IRowContainerProps,
  'itemCount' | 'cardAspectRatio' | 'children' | 'visibleCards'
> {
  children?: React.ReactNode
  childrenType?: string
  currentIndex?: number
  nextButtonVisible: boolean
  prev: () => void
  next: () => void
  onSeeAllClick?: () => void
  isRenderSpecialCell?: boolean
  paddings?: (typeof RowPaddings)[keyof typeof RowPaddings]
}

const ButtonSeeAll = ({
  buttonTitle,
  onSeeAllClick,
}: {
  buttonTitle?: string
  onSeeAllClick?: () => void
}): JSX.Element => (
  <InlineForwardArrowWithTitle
    title={buttonTitle}
    onClick={onSeeAllClick}
    icon={IconNames.angleRight}
  />
)

export const RowTitle = ({
  children,
  controlsType,
  currentIndex,
  titleColor,
  title,
  nextButtonVisible,
  prev,
  next,
  buttonTitle,
  onSeeAllClick,
  isMoreThanOnePage,
}: IRowTitle): JSX.Element | null => {
  const controlsInHeader = useMemo(
    () => controlsType === RowControlsType.inHeader,
    [controlsType]
  )

  return children || title ? (
    <RowTitleSC>
      {children ? (
        children
      ) : (
        <ContainerHeaderWithTitleOnly title={title!} color={titleColor}>
          {controlsInHeader && (
            <HeaderControls
              currentIndex={currentIndex}
              nextButtonVisible={nextButtonVisible}
              prev={prev}
              next={next}
              controlsType={controlsType}
            />
          )}
          {isMoreThanOnePage && (
            <ButtonSeeAll
              onSeeAllClick={onSeeAllClick}
              buttonTitle={buttonTitle}
            />
          )}
        </ContainerHeaderWithTitleOnly>
      )}
    </RowTitleSC>
  ) : null
}

RowTitle.displayName = 'RowTitle'
